export default function LoginBrand() {
  return (
    <div className="text-center mb-8 flex flex-col items-center justify-center">
      <img
        src="/img/logo-pringsewu.png"
        alt="Logo RSUD Pringsewu"
        className="w-20 h-20 object-contain mb-4"
      />
      <h1
        className="
          text-4xl
          font-extrabold
          text-slate-900
          tracking-tight
          mb-2
        "
      >
        RSUD Pringsewu
      </h1>

      <p
        className="
          text-slate-500
          text-base
        "
      >
        Sistem Informasi Instalasi Gizi
      </p>
    </div>
  );
}
